"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAllProduct = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var oeProductChooserApiPath = process.env.REACT_APP_OE_PRODUCT_CHOOSER_API_URL;

var fetchAllProduct = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(axiosInstance, callBack) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosInstance.get(oeProductChooserApiPath + "/oepcdbproducts").then(function (response) {
              return response.data;
            }).then(function (data) {
              return callBack(data);
            }).catch(function (error) {
              console.log(error);
              callBack(undefined);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllProduct(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchAllProduct = fetchAllProduct;